export const bulkManagementScope = ['simplified', 'full'] as const

export type BulkManagementScope = (typeof bulkManagementScope)[number]
